<div
  class="button-container"
  [class.drag-over]="isDragOver"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <div class="image-attach-container">
    <label>
      <input
        type="file"
        accept="image/*,image/heic,image/heif"
        multiple="false"
        (change)="attachImage($event)"
        style="display: none"
        #fileInput
      />
      <i class="fa-light fa-image fa-xl"></i>
      <p class="body bold">Attach Image</p>
    </label>
  </div>

  <div class="image-attach-container mob">
    <label>
      <input
        type="file"
        accept="image/*"
        capture="environment"
        (change)="attachImage($event)"
        style="display: none"
        #cameraInput
      />
      <i class="fa-light fa-camera fa-xl"></i>
      <p class="body bold">Take Photo</p>
    </label>
  </div>
</div>
